/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_EmailInputs */

const en_contact_channel_email = /** @type {(inputs: Contact_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const lv_contact_channel_email = /** @type {(inputs: Contact_Channel_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pasts`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Contact_Channel_EmailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_email = /** @type {((inputs?: Contact_Channel_EmailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_EmailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_email(inputs)
	return en_contact_channel_email(inputs)
});